// extracted by mini-css-extract-plugin
export default {"code":"CodeNodeView_code__Qi4bu"};